export class SessionConstants {
	public static SESSION_TOKEN = 'authToken';
	public static SESSION_USER = 'user';
}
